<script>
  import { fly } from 'svelte/transition';
  // import Modal from './Modal.svelte';
  
  export let show = false;
  export let page = '';
  export let pageSelect
  export let logout

  // let modal_show = false;
  const navigate = (p) => {
    if (p === 'wordle') {
      location.hash = ''
      if (page === 'wordle')
        location.reload()
    }
    pageSelect(p)
    show = false
  }
</script>

{#if show}
  <nav transition:fly={{x: -300, opacity: 1}} class="fixed flex flex-col top-0 left-0 z-50 h-full overflow-y-auto bg-white w-[300px] border-r">
    <button class="p-2 flex items-center justify-end text-2xl focus:outline-none border-b" on:click={() => {show = false;}}>
      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
    <!-- <button class="p-2" on:click={() => {modal_show = true; show = false;}}>About</button> -->
    <button class={`p-2 flex items-center text-2xl focus:outline-none border-b${ page === 'dashboard' ? ' text-teal-700' : ''}`} on:click={() => navigate('dashboard')}>Dashboard</button>
    <button class={`p-2 flex items-center text-2xl focus:outline-none border-b${ page === 'wordle' ? ' text-teal-700' : ''}`} on:click={() => navigate('wordle')}>Daily Word</button>
    <button class={`p-2 flex items-center text-2xl focus:outline-none border-b${ page === 'createChallenge' ? ' text-teal-700' : ''}`} on:click={() => navigate('createChallenge')}>Custom Challenge</button>
    <button class={`p-2 flex items-center text-2xl focus:outline-none border-b${ page === 'boggle' ? ' text-teal-700' : ''}`} on:click={() => navigate('boggle')}>Boggle Board</button>
    <button class="p-2 flex items-center text-2xl focus:outline-none border-b" on:click={() => {logout(); show = false;}}>Logout</button>
  </nav>
{/if}
<!-- <Modal bind:show={modal_show} /> -->
